import { render, staticRenderFns } from "./personalcenter1.vue?vue&type=template&id=3b415294&scoped=true&"
import script from "./personalcenter1.js?vue&type=script&lang=js&"
export * from "./personalcenter1.js?vue&type=script&lang=js&"
import style0 from "./personalcenter1.vue?vue&type=style&index=0&id=3b415294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b415294",
  null
  
)

export default component.exports